module.exports = "<app-navbar></app-navbar>\n<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main